(function () {
  async function getShopifyCartId() {
    const cookieMatch = `; ${document.cookie}`.match(/;\s*cart=([^;]+)/);
    if (cookieMatch) {
      return cookieMatch[1].slice(-10);
    }

    const response = await fetch("/cart.js", {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not load the current cart");
    }

    const cart = await response.json();
    return cart.token ? cart.token.slice(-10) : null;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { error: text };
    }
  }

  async function removeFramefoxBackstory(button) {
    if (!button || button.dataset.removing === "true") {
      return;
    }

    button.dataset.removing = "true";
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    const originalLabel = button.textContent;
    button.textContent = "Removing";

    try {
      const shopifyCartId = await getShopifyCartId();

      if (!shopifyCartId) {
        throw new Error("Could not determine the current Shopify cart");
      }

      const clearResponse = await fetch(
        `/apps/frame/draft_order_items/${button.dataset.draftOrderItemId}/remove_backstory`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            shopify_cart_id: shopifyCartId,
          }),
        },
      );

      const clearPayload = await parseJsonResponse(clearResponse);

      if (!clearResponse.ok) {
        throw new Error(clearPayload.error || "Could not clear the backstory from the draft order item");
      }

      const cartResponse = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: button.dataset.backstoryLineId,
          quantity: 0,
        }),
      });

      const cartPayload = await parseJsonResponse(cartResponse);

      if (!cartResponse.ok) {
        throw new Error(cartPayload.description || cartPayload.error || "Could not remove the backstory from your cart");
      }

      window.location.reload();
    } catch (error) {
      console.error("Error removing Framefox backstory:", error);
      alert(error.message || "Failed to remove backstory. Please try again.");
    } finally {
      button.dataset.removing = "false";
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.textContent = originalLabel;
    }
  }

  window.removeFramefoxBackstory = removeFramefoxBackstory;
})();
